/**
 * @owner @Appboy/messaging-experience
 */
import { pushTypes } from "@lib/campaignMessageTypeConstants";
import type { SelectableMessageType } from "@lib/campaignMessageTypeConstants";
import sharedConstants from "@lib/shared_constants";

const { CAMPAIGN_MESSAGE_TYPES } = sharedConstants;

/**
 * Canvas Message Prioritization allowlist from the MX empty-state Figma.
 * Anything not in this set — including KakaoTalk, banners, Content Cards, and in-app
 * messages — sends without Message Prioritization.
 */
const messagePrioritizationEligibleChannels = new Set<SelectableMessageType>([
  CAMPAIGN_MESSAGE_TYPES.EMAIL,
  CAMPAIGN_MESSAGE_TYPES.LINE,
  CAMPAIGN_MESSAGE_TYPES.SMS,
  CAMPAIGN_MESSAGE_TYPES.WEBHOOK,
  CAMPAIGN_MESSAGE_TYPES.WHATS_APP,
  CAMPAIGN_MESSAGE_TYPES.PUSH,
  ...pushTypes,
]);

/**
 * Whether a single channel can receive Message Prioritization delivery settings.
 *
 * @param channel - A selectable Canvas/campaign message type.
 * @returns True when the channel is on the Message Prioritization allowlist.
 */
export const isMessagePrioritizationEligibleChannel = (channel: SelectableMessageType): boolean => {
  return messagePrioritizationEligibleChannels.has(channel);
};
